var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 900",
    width: 900,
    height: 900,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414 457L380 454L396 508Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 454L366 512L396 508Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 454L346 470L366 512Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 454L340 458L346 470Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346 470L331 487L366 512Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 458L331 487L346 470Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414 457L363 417L380 454Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 454L363 417L340 458Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396 508L470 483L414 457Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357 364L355 401L396 352Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 458L309 479L331 487Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 517L364 560L366 512Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293 481L309 479L261 451Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 517L366 512L331 487Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366 512L364 560L396 508Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396 508L472 524L470 483Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 401L363 417L396 352Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 417L355 401L340 458Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 536L472 524L396 508Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382 573L464 536L396 508Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364 560L382 573L396 508Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 516L489 463L470 483Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 483L490 450L414 457Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 479L306 517L331 487Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489 463L490 450L470 483Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261 451L309 479L340 458Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 479L293 481L306 517Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 480L495 441L490 450Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490 450L495 441L414 457Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 517L357 582L364 560Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364 560L357 582L382 573Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348 613L360 587L357 582Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357 582L360 587L382 573Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382 573L419 595L464 536Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 536L500 526L472 524Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472 524L500 526L470 483Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489 463L531 480L490 450Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481 584L500 526L464 536Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 600L419 595L382 573Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396 352L363 417L414 457Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 401L261 451L340 458Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 587L392 600L382 573Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536 536L513 516L500 526Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 526L513 516L470 483Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441 333L396 352L414 457Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561 464L507 408L495 441Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495 441L507 408L414 457Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 615L481 584L419 595Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 595L481 584L464 536Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544 526L531 480L513 516Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 516L531 480L489 463Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 356L261 451L355 401Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293 481L246 506L306 517Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 333L348 348L357 364Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357 364L306 356L355 401Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 600L348 613L357 582Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 587L348 613L392 600Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 622L471 615L419 595Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 600L357 582L306 517Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 333L334 345L348 348Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348 348L334 345L357 364Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261 451L246 506L293 481Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 345L306 356L357 364Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396 352L353 333L357 364Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 345L323 328L306 356Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 567L536 536L500 526Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 583L302 600L306 517Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 408L441 333L414 457Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396 352L392 279L353 333Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544 390L504 371L507 408Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 408L501 366L441 333Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504 371L501 366L507 408Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481 584L523 567L500 526Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 622L419 595L441 654Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481 584L531 587L523 567Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 574L544 526L536 536Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536 536L544 526L513 516Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 480L561 464L495 441Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407 659L419 595L392 600Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 615L531 587L481 584Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544 526L561 464L531 480Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504 371L560 371L501 366Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 257L323 328L353 333Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 333L323 328L334 345Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 600L341 641L348 613Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348 613L407 659L392 600Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 328L287 345L306 356Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 356L236 381L261 451Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 485L216 515L246 506Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577 433L544 390L507 408Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519 669L531 587L471 615Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 567L563 574L536 536Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606 455L577 433L561 464Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501 366L463 318L441 333Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441 333L392 279L396 352Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458 305L463 318L491 261Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 641L407 659L348 613Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544 673L576 604L531 587Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407 659L441 654L419 595Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 485L246 506L261 451Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 506L233 583L306 517Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 600L282 647L341 641Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562 323L463 318L501 366Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463 318L458 305L441 333Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287 345L236 381L306 356Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599 521L561 464L544 526Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561 464L577 433L507 408Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 496L211 535L216 515Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 515L211 535L246 506Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 535L233 583L246 506Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287 345L262 339L236 381Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 320L262 339L287 345Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576 604L563 574L531 587Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 587L563 574L523 567Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 672L366 671L341 641Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 641L366 671L407 659Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407 659L407 673L441 654Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366 671L407 673L407 659Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577 433L560 371L544 390Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544 390L560 371L504 371Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 271L392 279L441 333Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 328L270 320L287 345Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 603L233 598L233 583Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 583L233 598L302 600Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 257L270 320L323 328Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 378L170 409L236 381Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 598L282 647L302 600Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 647L323 672L341 641Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366 671L370 689L407 673Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 452L189 485L261 451Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 605L224 603L233 583Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 574L599 521L544 526Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 409L188 452L236 381Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 381L188 452L261 451Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458 305L427 271L441 333Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 261L427 271L458 305Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 605L233 583L211 535Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 598L224 603L282 647Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 700L370 689L366 671Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599 521L606 455L561 464Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577 433L598 367L560 371Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 452L181 480L189 485Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 485L180 496L216 515Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 480L180 496L189 485Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 271L398 263L392 279Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 279L326 257L353 333Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519 669L471 615L467 622Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 574L629 539L599 521Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519 669L467 622L441 654Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519 669L441 654L430 732Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621 465L614 436L606 455Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606 455L614 436L577 433Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 528L621 465L599 521Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599 521L621 465L606 455Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430 732L441 654L407 673Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 672L341 700L366 671Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 689L378 706L407 673Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 685L341 700L323 672Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349 708L341 700L345 763Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361 708L378 706L370 689Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598 367L562 323L560 371Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 371L562 323L501 366Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 700L361 708L370 689Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624 368L598 367L614 436Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614 436L598 367L577 433Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398 263L326 257L392 279Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 685L323 672L282 647Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 700L349 708L361 708Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138 577L198 605L211 535Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 665L276 685L282 647Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 381L262 339L209 311Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 378L236 381L179 347Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 467L126 504L181 480Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 480L126 504L180 496Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 302L262 339L270 320Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 665L282 647L224 603Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544 673L591 614L576 604Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576 604L629 539L563 574Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 274L491 261L463 318Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 271L389 217L398 263Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 217L323 241L326 257Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598 367L574 318L562 323Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562 323L550 274L463 318Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591 614L629 539L576 604Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 251L230 302L270 320Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508 759L544 673L519 669Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519 669L544 673L531 587Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561 678L596 619L591 614Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591 614L656 586L629 539Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 217L326 257L398 263Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 257L235 251L270 320Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 301L209 311L230 302Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 302L209 311L262 339Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659 540L643 528L629 539Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629 539L643 528L599 521Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637 376L624 368L614 436Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 311L179 347L236 381Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 383L118 429L170 409Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361 708L388 732L378 706Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378 706L430 732L407 673Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345 763L388 732L361 708Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406 753L388 732L345 763Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637 376L676 396L654 376Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598 367L624 368L574 318Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388 732L430 732L378 706Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561 678L604 628L596 619Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596 619L646 607L591 614Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583 300L562 323L574 318Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583 300L550 274L562 323Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508 759L561 678L544 673Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544 673L561 678L591 614Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624 368L583 300L574 318Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 203L427 271L491 261Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 203L389 217L427 271Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637 376L614 436L676 396Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624 368L641 289L583 300Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 272L197 301L230 302Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 311L197 301L179 347Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583 300L552 261L550 274Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 274L552 261L491 261Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 467L181 480L188 452Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 496L138 577L211 535Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 467L188 452L118 429Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656 586L659 540L629 539Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 528L684 508L621 465Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388 732L414 750L430 732Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430 732L508 759L519 669Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406 753L414 750L388 732Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345 763L361 708L349 708Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 504L123 517L180 496Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 517L138 577L180 496Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 716L262 732L276 685Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 409L182 378L126 383Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 429L188 452L170 409Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 504L90 499L123 517Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 209L235 251L323 241Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 241L235 251L326 257Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676 396L614 436L621 465Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637 376L654 376L624 368Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583 300L553 239L552 261Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522 211L443 203L491 261Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 173L213 253L235 251Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 569L134 582L138 577Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138 577L134 582L198 605Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 383L182 378L179 347Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648 628L646 607L604 628Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604 628L646 607L596 619Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646 607L656 586L591 614Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 251L203 272L230 302Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 301L170 305L179 347Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 272L170 305L197 301Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619 681L602 674L617 777Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561 678L602 674L604 628Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 305L126 383L179 347Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 665L224 603L198 605Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 685L262 732L341 700Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 645L176 665L198 605Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641 289L553 239L583 300Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 261L535 225L491 261Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262 732L345 763L341 700Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 517L120 569L138 577Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 582L134 645L198 605Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 572L120 569L93 549Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553 239L535 225L552 261Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 271L74 317L170 305Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 251L213 253L203 272Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 209L323 241L281 185Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682 545L684 508L659 540Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659 540L684 508L643 528Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 549L120 569L123 517Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 569L118 572L134 582Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724 480L676 396L621 465Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654 376L641 289L624 368Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646 607L717 630L656 586Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656 586L682 545L659 540Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649 644L648 628L604 628Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743 540L682 545L743 562Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 777L430 732L414 750Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 777L468 765L430 732Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 777L414 750L406 753Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273 207L275 209L281 185Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 429L104 424L118 467Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 467L90 499L126 504Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 383L104 424L118 429Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535 225L522 211L491 261Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 201L522 211L535 225Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281 185L323 241L291 166Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 209L273 207L235 251Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436 806L475 767L468 765Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468 765L508 759L430 732Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409 799L423 777L406 753Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602 674L649 644L604 628Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617 777L602 674L561 678Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 767L508 759L468 765Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619 681L649 644L602 674Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717 630L682 545L656 586Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 433L90 499L118 467Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724 480L689 394L676 396Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676 396L689 371L654 376Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 151L433 173L443 203Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 203L433 173L389 217Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 579L134 645L134 582Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 665L185 716L276 685Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 579L134 582L118 572Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 543L93 549L123 517Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686 307L641 289L654 376Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553 239L558 201L535 225Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689 394L689 371L676 396Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 166L323 241L389 217Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273 207L244 173L235 251Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 721L185 716L176 665Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 812L409 799L345 763Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 499L84 543L123 517Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 549L92 579L118 572Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 543L92 579L93 549Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345 763L409 799L406 753Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 777L436 806L468 765Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503 797L516 788L508 759Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 780L345 763L262 732Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633 200L558 201L553 239Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522 211L507 151L443 203Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 811L275 780L262 732Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 729L177 721L176 665Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 716L232 811L262 732Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 744L177 721L126 729Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743 540L724 480L684 508Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684 508L724 480L621 465Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689 394L740 367L689 371Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743 540L684 508L682 545Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 900L436 806L409 799Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409 799L436 806L423 777Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 114L291 166L389 217Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281 185L244 173L273 207Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503 797L508 759L475 767Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508 759L617 777L561 678Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436 806L503 797L475 767Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689 371L686 307L654 376Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641 289L633 200L553 239Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740 367L686 307L689 371Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 780L332 812L345 763Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 166L244 173L281 185Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 317L81 339L170 305Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 305L81 339L126 383Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 305L203 272L98 271Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 383L81 339L104 424Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 424L46 433L118 467Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 499L0 504L84 543Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686 307L660 259L641 289Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 811L270 801L275 780Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 780L270 801L332 812Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 106L507 151L558 201Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 201L507 151L522 211Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433 173L403 117L389 217Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 867L340 825L332 812Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 812L340 825L409 799Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 848L524 840L503 797Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 416L46 433L104 424Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 562L49 620L92 579Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717 630L648 628L649 644Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717 630L646 607L648 628Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764 422L740 367L689 394Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700 692L649 644L619 681Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700 692L717 630L649 644Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717 630L743 562L682 545Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 271L203 272L139 196Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 339L35 416L104 424Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743 562L751 533L743 540Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743 540L751 533L724 480Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 729L176 665L134 645Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 721L232 811L185 716Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411 115L403 117L433 173Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 143L228 157L244 173Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 196L203 272L213 253Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 143L244 173L291 166Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 173L163 180L213 253Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764 422L689 394L724 480Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686 307L683 241L660 259Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479 114L477 125L507 151Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 151L477 125L433 173Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477 125L411 115L433 173Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 117L325 114L389 217Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 412L35 416L0 369Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 562L92 579L84 543Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 241L633 200L660 259Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660 259L633 200L641 289Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 703L126 729L134 645Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 656L134 645L92 579Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 744L232 811L177 721Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 801L333 867L332 812Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 811L232 811L150 744Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 79L325 114L403 117Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 848L617 777L516 788Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516 788L617 777L508 759Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678 743L700 692L619 681Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791 560L751 533L743 562Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767 434L764 422L724 480Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 504L90 499L46 433Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704 207L683 241L743 222Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522 71L479 114L507 151Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477 125L479 114L411 115Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411 115L404 101L403 117Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 832L622 777L617 777Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617 777L622 777L619 681Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524 840L516 788L503 797Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788 469L767 434L724 480Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 114L228 143L291 166Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 157L163 180L244 173Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 620L64 656L92 579Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479 114L404 101L411 115Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 154L163 180L228 157Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791 560L771 523L751 533Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751 533L771 523L724 480Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752 608L743 562L717 630Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782 635L752 608L717 630Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 178L609 165L633 200Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633 200L609 165L558 201Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 180L139 196L213 253Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 848L503 797L436 806Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688 757L678 743L622 777Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622 777L678 743L619 681Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700 692L732 684L717 630Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481 896L512 848L436 806Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 818L688 757L622 777Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 900L409 799L340 825Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 154L146 177L163 180Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 180L146 177L139 196Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 193L68 250L98 271Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 369L81 339L0 317Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 126L228 157L228 143Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 126L175 154L228 157Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 900L333 867L270 801Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797 496L788 469L771 523Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771 523L788 469L724 480Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824 424L804 385L764 422Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798 349L686 307L740 367Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704 207L670 191L683 241Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737 699L732 684L700 692Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 412L46 433L35 416Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 412L0 504L46 433Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 620L45 671L64 656Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 114L214 126L228 143Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 48L214 126L325 114Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 250L74 317L98 271Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 369L35 416L81 339Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 241L670 191L633 200Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 178L670 191L704 207Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 504L0 532L84 543Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 193L98 271L139 196Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 641L45 671L49 620Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 656L59 703L134 645Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 729L140 788L150 744Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 772L140 788L126 729Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 900L339 900L333 867Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404 70L367 79L404 101Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404 101L367 79L403 117Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791 560L797 496L771 523Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791 560L743 562L788 603Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 532L0 562L84 543Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 671L59 703L64 656Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 848L516 788L524 840Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740 703L737 699L718 749Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788 603L743 562L752 608Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 241L686 307L743 222Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670 191L667 178L633 200Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609 165L572 106L558 201Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737 699L700 692L718 749Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782 635L788 603L752 608Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407 39L404 70L479 114Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479 114L404 70L404 101Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 812L156 811L140 788Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 788L156 811L150 744Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 135L171 136L139 73Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 126L171 136L175 154Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 154L128 135L146 177Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 153L88 193L139 196Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506 894L527 867L512 848Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 848L527 867L524 840Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 317L81 339L74 317Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 412L0 369L0 504Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 824L154 812L140 788Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 900L242 900L232 811Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 714L59 716L59 703Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 703L59 716L126 729Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 714L59 703L45 671Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718 749L700 692L678 743Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737 699L740 703L732 684Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807 464L767 434L788 469Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804 385L740 367L764 422Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782 635L717 630L732 684Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850 449L807 464L797 496Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850 449L797 496L892 477Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797 496L807 464L788 469Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 110L572 106L609 165Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637 89L609 165L667 178Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637 89L587 110L609 165Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 867L587 848L524 840Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740 703L782 635L732 684Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 153L139 196L146 177Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 313L0 317L74 317Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824 424L764 422L767 434Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688 757L718 749L678 743Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809 635L798 621L782 635Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717 760L718 749L688 757Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 900L425 900L333 867Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 867L425 900L340 825Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 867L568 903L587 848Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804 385L798 349L740 367Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 685L42 714L45 671Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 772L142 824L140 788Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 900L270 801L279 900Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 562L0 638L49 620Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 900L481 896L436 806Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 313L74 317L68 250Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 638L0 641L49 620Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535 50L522 71L572 106Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 106L522 71L507 151Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782 635L798 621L788 603Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788 603L869 608L791 560Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809 635L782 635L822 713Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710 794L717 760L688 757Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718 749L754 757L740 703Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 153L69 202L88 193Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 193L69 202L68 250Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 772L126 729L59 716Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 812L142 824L156 811Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 247L0 313L68 250Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 900L476 900L481 896Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481 896L506 894L512 848Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 714L81 772L59 716Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489 900L506 894L481 896Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 900L489 900L481 896Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 900L643 832L587 848Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 848L643 832L617 777Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529 900L532 889L506 894Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506 894L532 889L527 867Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807 464L824 424L767 434Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804 385L827 344L798 349Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850 449L824 424L807 464Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801 255L743 222L686 307Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704 207L742 151L667 178Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 900L270 801L266 900Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489 900L502 900L506 894Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 832L667 818L622 777Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 136L128 135L175 154Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 84L171 136L214 126Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 48L325 114L323 41Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266 900L270 801L232 811Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522 71L407 39L479 114Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404 70L407 39L367 79Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 135L99 153L146 177Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 200L20 234L68 250Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242 900L266 900L232 811Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 41L325 114L367 79Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407 39L341 41L367 79Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502 900L529 900L506 894Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 889L568 903L527 867Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757 780L710 794L700 860Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822 713L782 635L740 703Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798 621L869 608L788 603Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 641L2 685L45 671Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 714L0 729L81 772Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 31L323 41L341 41Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 41L323 41L367 79Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 73L192 84L199 30Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 48L192 84L214 126Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 135L100 137L99 153Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700 860L667 818L643 832Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 818L710 794L688 757Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717 760L754 757L718 749Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 200L68 250L69 202Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 900L232 811L156 811Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 852L136 848L142 824Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 824L136 848L156 811Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 852L142 824L81 772Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537 43L535 50L543 39Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522 71L487 0L407 39Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535 50L572 106L543 39Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 0L340 31L341 41Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 41L297 0L304 48Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 0L341 41L407 39Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 87L100 137L128 135Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 153L37 200L69 202Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889 363L827 344L804 385Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798 349L801 255L686 307Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 193L37 200L0 174Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757 780L754 757L717 760Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884 436L850 449L892 477Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824 424L889 363L804 385Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755 175L745 186L794 191Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743 222L745 186L704 207Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 234L0 247L68 250Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 239L0 247L20 234Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 952L568 903L529 900Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529 900L568 903L532 889Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 952L529 900L502 900Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 952L502 900L489 900Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 952L489 900L476 900Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 952L476 900L425 900Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 952L425 900L339 900Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 952L339 900L137 946Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 900L289 900L137 946Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 900L279 900L137 946Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543 39L572 106L587 110Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535 50L487 0L522 71Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742 151L637 89L667 178Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 216L0 239L20 234Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 848L197 900L156 811Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 824L122 852L81 772Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809 265L801 255L798 349Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637 89L543 39L587 110Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537 43L487 0L535 50Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 895L197 900L136 848Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 946L279 900L266 900Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 344L809 265L798 349Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9 735L0 729L2 685Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 685L0 729L42 714Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710 794L757 780L717 760Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754 757L809 728L740 703Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700 860L710 794L667 818Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794 191L743 222L816 223Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794 191L745 186L743 222Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745 186L742 151L704 207Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 193L0 216L37 200Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 200L0 216L20 234Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 174L37 200L-2 153Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755 175L742 151L745 186Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770 136L742 151L755 175Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 641L-9 735L2 685Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 729L0 799L81 772Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41 796L-9 735L0 641Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41 796L0 641L0 638Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41 796L0 638L0 562Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41 796L0 562L0 532Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41 796L0 532L0 504Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41 796L0 504L0 369Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41 796L0 369L0 317Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41 796L0 317L0 313Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41 796L0 313L0 247Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2 153L0 247L0 239Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488 -22L371 0L407 39Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 31L315 -1L323 41Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 0L369 0L340 31Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 30L192 84L304 48Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 84L139 73L171 136Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2 153L37 200L18 118Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 900L136 848L122 852Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 900L152 895L136 848Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816 781L809 728L754 757Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892 477L797 496L900 545Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 -45L315 -1L369 0Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369 0L315 -1L340 31Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809 728L822 713L740 703Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 0L537 43L543 39Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522 -4L487 0L537 43Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 0L488 -22L369 0Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 0L543 39L542 0Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 900L700 860L643 832Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757 780L816 781L754 757Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809 728L855 718L822 713Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 -1L297 0L323 41Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 0L199 30L304 48Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869 608L798 621L809 635Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850 449L884 436L824 424Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 226L801 255L809 265Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 627L869 608L900 668Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816 223L801 255L827 226Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816 223L743 222L801 255Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 226L809 265L848 234Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 -45L267 0L297 0Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297 0L267 0L304 48Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836 163L793 183L794 191Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794 191L793 183L755 175Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 42L90 87L87 0Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 73L90 87L128 135Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 900L131 900L122 852Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 895L137 946L197 900Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 946L266 900L242 900Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 545L797 496L791 560Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 0L543 39L560 0Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487 0L488 -22L407 39Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543 39L572 0L560 0Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 200L99 153L18 118Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 193L0 174L0 216Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 216L-2 153L0 239Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 0L522 -4L537 43Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816 223L836 163L794 191Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848 234L809 265L900 269Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 58L637 89L735 71Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 0L542 0L522 -4Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735 71L637 89L742 151Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892 477L900 441L884 436Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 394L889 363L824 424Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 545L900 474L892 477Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 474L900 441L892 477Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 0L543 39L617 0Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 0L584 -11L522 -4Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 394L824 424L884 436Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793 183L770 136L755 175Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801 125L770 136L793 183Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9 735L0 799L0 729Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 563L791 560L869 608Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 563L900 545L791 560Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584 -11L488 -22L522 -4Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522 -4L488 -22L487 0Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 -1L168 -45L297 0Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568 903L683 900L587 848Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825 900L816 781L757 780Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617 0L543 39L637 89Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 0L584 -11L542 0Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 608L900 563L869 608Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 441L900 394L884 436Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41 796L0 807L0 799Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 799L0 807L81 772Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 118L99 153L100 137Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 174L-2 153L0 216Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 0L207 0L199 30Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 30L154 0L139 73Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 87L18 118L100 137Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 -45L207 0L267 0Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 269L809 265L827 344Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 226L836 163L816 223Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904 345L827 344L889 363Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 394L900 373L889 363Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 -45L198 0L207 0Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207 0L198 0L199 30Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 900L757 780L700 860Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822 713L855 718L809 635Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816 781L855 718L809 728Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 627L900 608L869 608Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 113L18 118L0 97Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 952L707 900L683 900Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 900L707 900L700 860Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41 796L0 824L0 807Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 807L0 824L81 772Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 0L584 -11L560 0Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617 0L584 -11L572 0Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617 0L637 89L667 58Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 668L869 608L809 635Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 441L904 345L900 394Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 394L904 345L900 373Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 373L904 345L889 363Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 474L904 345L900 441Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922 743L904 345L900 474Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922 743L900 474L900 545Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922 743L900 545L900 563Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922 743L900 563L900 608Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634 0L617 0L667 58Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 269L855 218L848 234Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848 234L855 218L827 226Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568 903L636 952L683 900Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 946L242 900L197 900Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801 125L735 71L770 136Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770 136L735 71L742 151Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 952L719 900L707 900Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707 900L719 900L700 860Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634 0L612 -7L617 0Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617 0L612 -7L584 -11Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 900L137 946L131 900Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 900L137 946L152 895Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 0L634 0L667 58Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 -45L154 0L198 0Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 0L154 0L199 30Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 97L18 118L56 42Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 118L0 113L-2 153Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836 163L801 125L793 183Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9 735L-41 796L0 799Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 824L44 900L122 852Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2 153L-41 796L0 247Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1 -37L-41 796L-2 153Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855 718L900 668L809 635Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 627L922 743L900 608Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 693L900 668L855 718Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 952L732 900L719 900Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719 900L732 900L700 860Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922 743L900 693L855 718Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 -45L143 0L154 0Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 0L143 0L139 73Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895 193L836 163L855 218Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855 218L836 163L827 226Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836 163L809 122L801 125Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801 125L809 122L735 71Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727 0L667 0L667 58Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904 345L900 269L827 344Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 900L44 900L0 824Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885 763L855 718L816 781Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 668L922 743L900 627Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 42L18 118L90 87Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 113L0 97L-2 153Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727 0L667 58L735 71Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634 0L625 -37L612 -7Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612 -7L625 -37L584 -11Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 0L90 87L139 73Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 900L22 900L0 824Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 900L0 928L137 946Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584 -11L625 -37L488 -22Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 -45L87 0L143 0Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 0L625 -37L634 0Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660 -53L625 -37L667 0Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869 789L885 763L816 781Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832 897L869 789L816 781Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 -45L369 0L488 -22Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 0L87 0L139 73Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 42L0 0L0 97Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660 -53L168 -45L488 -22Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894 94L839 70L809 122Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762 -2L727 0L735 71Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 197L895 193L855 218Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41 796L0 900L0 824Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 900L0 928L44 900Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904 345L900 197L900 269Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 269L900 197L855 218Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839 70L735 71L809 122Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 180L836 163L895 193Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904 345L900 180L900 197Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 197L900 180L895 193Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 785L922 743L885 763Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885 763L922 743L855 718Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 693L922 743L900 668Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904 345L900 152L900 180Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 801L900 785L869 789Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869 789L900 785L885 763Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727 0L660 -53L667 0Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625 -37L660 -53L488 -22Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41 796L0 928L0 900Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 900L0 928L22 900Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832 897L900 801L869 789Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 785L916 804L922 743Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 143L900 152L904 345Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 180L900 152L836 163Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 952L825 900L732 900Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 900L825 900L757 780Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 109L809 122L836 163Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727 0L762 -2L660 -53Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825 900L832 897L816 781Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771 0L762 -2L735 71Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 952L831 900L825 900Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825 900L831 900L832 897Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 900L916 804L900 801Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 109L900 143L904 345Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 152L900 143L836 163Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839 70L771 0L735 71Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762 -2L877 -16L660 -53Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 801L916 804L900 785Z",
    fill: "#f7eb79",
    stroke: "#f7eb79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 900L900 801L832 897Z",
    fill: "#dac826",
    stroke: "#dac826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 -49L0 0L87 0Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 0L0 0L56 42Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 97L0 0L-2 153Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 65L900 109L904 345Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 143L900 109L836 163Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839 70L852 0L771 0Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 109L894 94L809 122Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894 94L878 67L839 70Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660 -53L18 -49L168 -45Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 -45L18 -49L87 0Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 -49L-1 -37L0 0Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L-1 -37L-2 153Z",
    fill: "#b5a61d",
    stroke: "#b5a61d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 109L900 65L894 94Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894 94L900 65L878 67Z",
    fill: "#cebd23",
    stroke: "#cebd23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878 67L852 0L839 70Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922 743L900 65L904 345Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 952L900 900L831 900Z",
    fill: "#e7d429",
    stroke: "#e7d429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831 900L900 900L832 897Z",
    fill: "#f6e75f",
    stroke: "#f6e75f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 0L852 0L878 67Z",
    fill: "#f5e240",
    stroke: "#f5e240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771 0L877 -16L762 -2Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 0L877 -16L852 0Z",
    fill: "#f4e02c",
    stroke: "#f4e02c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852 0L877 -16L771 0Z",
    fill: "#f5e550",
    stroke: "#f5e550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 65L900 0L878 67Z",
    fill: "#f6e96c",
    stroke: "#f6e96c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922 743L900 0L900 65Z",
    fill: "#c1b120",
    stroke: "#c1b120"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoly);
export default __webpack_public_path__ + "static/media/poly.2dec131da6959187c35fb900db55bad4.svg";
export { ForwardRef as ReactComponent };